import { FC, memo, useCallback, useMemo } from 'react'
import {
    StyledRatingBar,
    StarIconWrapper,
    Ratings,
    TotalRating,
    StyledStarIcon,
    RecommendationPercentage,
} from './styles'
import { useTranslation } from '../../../hooks/locale'
import { Typography } from 'react-components'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { SECTION_IDS } from '../constants'
import { scrollToSection } from '../navigation-bar'

interface RatingsBarProps {
    ratingCount: number
    averageRating: string
    trust?: Record<string, string | null>
    isEnquiryPopup?: boolean
}

const RatingsBar: FC<RatingsBarProps> = ({ ratingCount, averageRating, trust, isEnquiryPopup = false }) => {
    const { t } = useTranslation()

    const ratingsText = useMemo(() => t('ratingsCount', { count: ratingCount }), [t, ratingCount])

    const scrollToReviews = useCallback((): void => {
        scrollToSection(SECTION_IDS.RATING_REVIEWS_SECTION_ID)
    }, [])

    if (Number(averageRating) === 0 || Number(ratingCount) === 0) {
        return null
    }

    return (
        <StyledRatingBar>
            <StarIconWrapper>
                <StyledStarIcon />
            </StarIconWrapper>
            <Ratings>
                <Typography variant={isEnquiryPopup ? 'caption' : 'button'}>{`${averageRating}/5`}</Typography>
            </Ratings>
            <TotalRating onClick={isEnquiryPopup ? undefined : scrollToReviews}>
                <Typography
                    variant={isEnquiryPopup ? 'caption' : 'button'}
                    color="tfwBlack40"
                    textDecoration={isEnquiryPopup ? 'none' : 'underline'}
                >
                    {ratingsText}
                </Typography>
            </TotalRating>
            {!isEmpty(get(trust, 'recommendationPercentage')) && (
                <RecommendationPercentage>
                    <Typography variant={isEnquiryPopup ? 'caption' : 'button'} color="tfwBlack40">
                        {get(trust, 'recommendationPercentage')}
                    </Typography>
                </RecommendationPercentage>
            )}
        </StyledRatingBar>
    )
}

export default memo(RatingsBar)
